<script>
  import Group from "$lib/admin/components/Group.svelte";
  import Input from "$lib/admin/components/Input.svelte";
  import { onMount } from "svelte";

  export let props = null;
  export let adminView = false;

  let isLiteLoaded = false;

  onMount(async () => {
    if (typeof window !== 'undefined') {
      await import('lite-youtube-embed/src/lite-yt-embed.js');
      isLiteLoaded = true;
    }
  });
</script>

{#if adminView}
  <Group colspan="8-4" addClass="form-item">
    <Input label="YouTube video code (11 chars)" placeholder="Insert YouTube code" bind:value={props.videoCode} on:keyup />
  </Group>
  <Group colspan="2-10" addClass="form-item">
    <Input label="Caption" placeholder="Write a caption" bind:value={props.videoCaption} on:keyup />
  </Group>
{:else}
  {#if props.videoCode}
    <div class="block block-video">
      <div class="container">
        <div class="grid">
          <div class="g-col-12 g-start-1 g-col-md-10 g-start-md-2">
            <div class="video-frame">
              {#if isLiteLoaded}
                <lite-youtube
                    videoid={props.videoCode}
                    playlabel={props.videoCaption}
                    style="background-image: url('https://i.ytimg.com/vi/{props.videoCode}/hqdefault.jpg'); max-width: 100%; border-radius: 6px;"
                >
                  <button type="button" class="lty-playbtn">
                    <span class="lyt-visually-hidden">Play {props.videoCaption}</span>
                  </button>
                </lite-youtube>
              {:else}
                <p>Loading video...</p>
              {/if}
            </div>
            {#if props.videoCaption}
              <p>{@html props.videoCaption}</p>
            {/if}
          </div>
        </div>
      </div>
    </div>
  {/if}
{/if}
